import React, { useEffect } from "react";

type CustomAlertProps = {
  title: string | null;
  message: string | null;
  htmlMessage: React.ReactElement | null;
  onClose: () => void;
};

const CustomAlert: React.FC<CustomAlertProps> = ({
  title,
  message,
  htmlMessage,
  onClose,
}) => {
  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert">
        <div className="custom-alert-content">
          <h2>{title}</h2>
            <div className="custom-alert-message">
            {htmlMessage ? (
              htmlMessage
            ) : (
              message?.split('\n').map((line: string, index: number) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
              ))
            )}
            </div>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;
